import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App/App';
import Routing from './components/Route/Route';

ReactDOM.render(<Routing />, document.querySelector('#root'));
